import { useEventCallback } from '@cian/react-utils';
import { useState, useCallback, useMemo, FC, PropsWithChildren } from 'react';
import { ChatContext, useApplicationContext } from '../../context';
import { useOffer, useUser } from '../../hooks';
import { requestAuthentication } from '../../services/requestAuthentication';

export const ChatContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const ctx = useApplicationContext();
  const { id } = useOffer();
  const user = useUser();

  const [offerWithChat, setOfferWithChat] = useState<number | null>(null);

  const updateOfferWithChat = useCallback(() => {
    setOfferWithChat(id);
  }, [id]);

  const closeChat = useEventCallback(() => {
    setOfferWithChat(null);
  });

  const openChat = useCallback(() => {
    if (!user.isAuthenticated) {
      requestAuthentication(ctx, { onSuccess: updateOfferWithChat });

      return;
    }

    updateOfferWithChat();
  }, [ctx, updateOfferWithChat, user]);

  const context = useMemo(() => ({ offerWithChat, openChat, closeChat }), [offerWithChat, openChat, closeChat]);

  return <ChatContext.Provider value={context}>{children}</ChatContext.Provider>;
};
